module.exports = __webpack_public_path__ + "img/sintesis.c47903cf.png";